import { render, staticRenderFns } from "./AddDpaAccountComponent.vue?vue&type=template&id=21216168&"
import script from "./AddDpaAccountComponent.vue?vue&type=script&lang=js&"
export * from "./AddDpaAccountComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports